import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const notificationUnreadCountQueryAtom = createQueryAtomFactory(
  'notifications.unreadCount',
  () => ({
    notificationUnreadCount: {
      __args: {
        channel: 'in_app' as const,
      },
    },
  }),
  {
    select: (data) => data?.notificationUnreadCount ?? 0,
    staleTime: 30_000,
    refetchInterval: 60_000,
  },
);
